// extracted by mini-css-extract-plugin
export default {"forgotPasswordContainer":"styles_forgotPasswordContainer__gojCg"};